import { isExecutive, isOrganizationAdmin, isPlatformExecutive, isProductCollaborator, isProductExecutive, isReportingManager, type Role } from "../session/roles.ts";
import { withFeature } from "./featureAccess.ts";

export const ADMIN_ONLY_ACCESS: readonly Role[] = [isOrganizationAdmin];

export const ORGANIZATION_PEOPLE_ACCESS: readonly Role[] = [isOrganizationAdmin, isPlatformExecutive];

export const PERFORMANCE_CYCLES_ACCESS: readonly Role[] = [isProductExecutive("wpm"), isProductCollaborator("wpm")];

export const REVIEW_CYCLE_CREATE_ACCESS: readonly Role[] = withFeature("PerformanceReviews", PERFORMANCE_CYCLES_ACCESS);

export const PULSE_SURVEY_SETUP_ACCESS: readonly Role[] = withFeature("Engagement", ORGANIZATION_PEOPLE_ACCESS);

export const GOOD_VIBES_COLLECTIONS_ACCESS: readonly Role[] = withFeature("Recognition", ORGANIZATION_PEOPLE_ACCESS);

export const PERFORMANCE_CYCLE_RESULTS_ACCESS: readonly Role[] = [isProductExecutive("wpm"), isReportingManager];

export const PERFORMANCE_CYCLE_DETAILS_ACCESS: readonly Role[] = [...PERFORMANCE_CYCLES_ACCESS, isReportingManager];

export const REVIEWEE_FILTER_OPTIONS_ACCESS: readonly Role[] = [isExecutive, ...PERFORMANCE_CYCLE_DETAILS_ACCESS];
